<div>
  <cc-top-bar [title]="('ORDER_NUMBER.GET_NUMBER' | translate)"></cc-top-bar>

  <main class="cc-box-wrapper">
    <cc-box>
      <section *ngIf="firstNumber$ | async; let firstNumber"
               class="main-section"
               content box>

        <h1 class="title" translate>FIRST_STEPS.GET_NUMBER_TITLE</h1>
        <p class="description" translate>FIRST_STEPS.GET_NUMBER_DESCRIPTION</p>


        <div class="number-wrapper">

          <span class="flag-icon flag-icon-{{firstNumber.countryCode}} m-r-sm shadow-up"></span>
          <span class="formatted-number">{{ firstNumber.formatted }}</span>

        </div>


        <div class="buttons-wrapper">

          <button
            mat-raised-button
            type="button"
            color="primary-full"
            [disabled]="orderingInitialNumber$ | async"
            (click)="startCalling(firstNumber)"
          >{{'FIRST_STEPS.START_CALLING' | translate}}
          </button>

          <button
            (click)="changeNumber()"
            mat-raised-button
            type="button"
            color="info-full"
          >{{'CHANGE' | translate}}
          </button>

        </div>

      </section>
    </cc-box>
  </main>

</div>
